<template>
  <div
    :class="{
      'wuyuan-menu': true,
      expand: state === 'expand',
    }"
    ref="menuRef"
  >
    <div
      class="item"
      v-for="menu in items"
      :key="menu.key"
      flex="dir:right main:center cross:center"
      :class="{ active: activeKey === menu.key }"
      @click="goView(menu.action, menu.withScene)"
    >
      <span>{{ menu.label }}</span>
    </div>

    <div v-if="slots.footer" class="footer" flex="dir:top cross:center corss:center">
      <slot name="footer"> </slot>
    </div>
    <div class="side" @click="changeMenuState()"></div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, inject, useSlots } from "vue"
import { MenuItemsType, MenuOptionsType, MenuTheme } from "./types.d"

const state = ref<string>("collapse")
const menuRef = ref<HTMLElement | null>(null)

const slots = useSlots()

interface WuyuanMenuProps {
  options?: MenuOptionsType
  items: MenuItemsType
  theme?: MenuTheme
  activeKey?: string
}

const router = inject("router") as any
const getScene = inject("getScene") as () => {
  scene: string
}

const props = withDefaults(defineProps<WuyuanMenuProps>(), {
  options: () => ({
    position: {
      left: 0,
      top: 0,
      zIndex: 1000,
    },
    defaultState: "collapse",
  }),
  items: () => [],
  theme: () => ({}),
  activeKey: () => "",
})

const emit = defineEmits(["update:activeKey"])

watch(
  () => props.activeKey,
  () => {
    if (props.activeKey) {
      emit("update:activeKey", props.activeKey)
    }
  },
)

function goView({ type, value }: { type: string; value: string }, withScene?: boolean): void {
  if (type === "LINK") {
    if (withScene) {
      const { scene } = getScene()
      // 判断 url 是否有？
      if (value.includes("?")) {
        value += `&scene=${scene}`
      } else {
        value += `?scene=${scene}`
      }
    }
    window.open(value)
  } else if (type === "GO_VPAGE") {
    router.push(`/page/${value}`)
  } else {
    router.push(value)
  }
  changeMenuState("collapse")
}

function changeMenuState(targetState: string | null = null): void {
  if (targetState) {
    state.value = targetState
  } else {
    state.value = state.value === "collapse" ? "expand" : "collapse"
  }
}

defineExpose({
  show() {
    changeMenuState("expand")
  },
  hide() {
    changeMenuState("collapse")
  },
  toggle() {
    changeMenuState()
  },
})

watch(
  () => state.value,
  () => {
    if (menuRef.value && state.value === "expand") {
      menuRef.value.style.animation = "slideLeft .2s forwards"
    }
  },
)
</script>

<style lang="scss">
.wuyuan-menu {
  position: absolute;
  top: 0;
  left: 0;
  width: 295px;
  height: 1080px;
  background-color: #081c3dff;
  box-sizing: border-box;
  padding: 48px;
  z-index: 1000;
  transition: all 0.2s ease-in;
  transform: translateX(-330px);
  &.expand {
    transform: translateX(0);
  }

  .item {
    width: 196px;
    height: 48px;
    background-image: url("./assets/menuList_bt_regular.png");
    background-size: cover;
    margin-bottom: 16px;
    cursor: pointer;

    & > span {
      color: #ffffffd9;
      font-size: 18px;
      font-weight: bold;
    }
  }

  .item.active,
  .item:hover {
    background-image: url("./assets/menuList_bt_hover.png");
    color: #a6f1feff;
  }

  .footer::before {
    content: "";
    width: 196px;
    height: 2px;
    background: #4b4f9673;
    position: absolute;
  }

  .footer {
    color: #fff;
    font-size: 16px;
    margin-top: 51px;

    a {
      color: #2bb7f7ff;
    }

    p {
      margin-top: 10px;
      text-align: center;
      width: 100%;
    }

    p:first-child {
      margin-top: 20px;
    }
  }

  .side {
    content: "";
    position: absolute;
    top: 0;
    right: -32px;
    background-image: url("./assets/menuList_img_close.png");
    width: 34px;
    height: 1080px;
    background-position: right;
    background-size: cover;
    cursor: pointer;
  }
}
</style>
